<template>
    <v-app>
        <v-container fluid>
            <v-row >
                <v-col md="3" cols="12">
                    <v-expansion-panels v-model="panel">
                        <v-expansion-panel>
                            <v-expansion-panel-title
                            color="blue-grey-lighten-4"
                            class="panel-header"
                            >
                                Others Info
                            </v-expansion-panel-title>
                            <v-expansion-panel-text>
                                <v-form
                                @submit.prevent="submitForm(currentStatus)"
                                ref="addPurOrder"
                                id="addPurOrder"
                                >
                                    <v-row class="pa-2">
                                        <v-col cols="12">
                                            <v-date-input
                                            input-format="dd/mm/yyyy"
                                            label="Payment Date"
                                            density="compact"
                                            prepend-icon=""
                                            prepend-inner-icon="mdi-calendar"
                                            variant="outlined"
                                            bg-color="grey-lighten-4"
                                            v-model="payment_date.value.value"
                                            :error-messages="payment_date.errorMessage.value"
                                            autocomplete="off"
                                            clearable
                                            >
                                                <template #label>
                                                    Payment Date
                                                    <span class="text-red-accent-4">*</span>
                                                </template>
                                            </v-date-input>

                                            <v-autocomplete
                                            variant="outlined"
                                            density="compact"
                                            bg-color="grey-lighten-4"
                                            v-model="payment_method.value.value"
                                            :items="getPaymentMethodList"
                                            :item-title="(item) => `${item.title}`"
                                            item-value="value"
                                            :error-messages="payment_method.errorMessage.value"
                                            autocomplete="off"
                                            clearable
                                            
                                                :menu-props="{ contentClass: 'my-custom-dropdown' }"
>
                                                <template #label>
                                                Payment Method
                                                <span class="text-red-accent-4">*</span>
                                                </template>
                                            </v-autocomplete>

                                            <v-autocomplete
                                            v-if="payment_method.value.value"
                                            variant="outlined"
                                            density="compact"
                                            bg-color="grey-lighten-4"
                                            v-model="payment_account_head_id.value.value"
                                            :items="getAccountHeadList"
                                            :item-title="(item) => `${item.name}`"
                                            item-value="id"
                                            :error-messages="payment_account_head_id.errorMessage.value"
                                            autocomplete="off"
                                            :loading="paymentAccountHeadLoading"
                                            clearable
                                            
                                                :menu-props="{ contentClass: 'my-custom-dropdown' }"
>
                                                <template #label>
                                                    Payment Account Head
                                                    <span class="text-red-accent-4">*</span>
                                                </template>
                                            </v-autocomplete>

                                            <v-autocomplete
                                            label="Year"
                                            variant="outlined"
                                            density="compact"
                                            bg-color="grey-lighten-4"
                                            v-model="year.value.value"
                                            :items="getYearsList"
                                            item-value="value"
                                            :error-messages="year.errorMessage.value"
                                            autocomplete="off"
                                            clearable
                                            
                                                :menu-props="{ contentClass: 'my-custom-dropdown' }"
>
                                                <template #label>
                                                    Year
                                                    <span class="text-red-accent-4">*</span>
                                                </template>
                                            </v-autocomplete>

                                            <v-autocomplete
                                            variant="outlined"
                                            density="compact"
                                            bg-color="grey-lighten-4"
                                            v-model="month.value.value"
                                            :items="getMonthsList"
                                            :item-title="(item)=> item.title"
                                            item-value="value"
                                            :error-messages="month.errorMessage.value"
                                            autocomplete="off"
                                            clearable
                                            
                                                :menu-props="{ contentClass: 'my-custom-dropdown' }"
>
                                                <template #label>
                                                    Month
                                                    <span class="text-red-accent-4">*</span>
                                                </template>
                                            </v-autocomplete>

                                            <v-autocomplete
                                            v-if="year.value.value && month.value.value"
                                            variant="outlined"
                                            density="compact"
                                            bg-color="grey-lighten-4"
                                            v-model="bonus_process_master_id.value.value"
                                            :items="getBonusProcessList"
                                            :item-title="(item) => `${item.code}`"
                                            item-value="id"
                                            :error-messages="bonus_process_master_id.errorMessage.value"
                                            @update:modelValue="onBonusProcessChange"
                                            autocomplete="off"
                                            :loading="bonusProcessMasterLoading"
                                            clearable
                                            
                                                :menu-props="{ contentClass: 'my-custom-dropdown' }"
>
                                                <template #label>
                                                    Bonus Process
                                                    <span class="text-red-accent-4">*</span>
                                                </template>
                                            </v-autocomplete>

                                        </v-col>
                                    </v-row>
                                </v-form>
                            </v-expansion-panel-text>
                        </v-expansion-panel>
                    </v-expansion-panels>
                </v-col>

                <v-col md="9" cols="12">
                    <v-expansion-panels v-model="panel2">
                        <v-expansion-panel>
                            <v-expansion-panel-title
                            color="blue-grey-lighten-4"
                            class="panel-header">
                                Item Info
                            </v-expansion-panel-title>

                            <v-expansion-panel-text>
                                <v-form
                                @submit.prevent="submitForm(currentStatus)"
                                ref="addPurOrder"
                                id="addPurOrder"
                                >

                                <v-row class="pt-0">
                                    <v-col cols="12">
                                        <v-table
                                        density="compact"
                                        :loading="loading"
                                        fixed-header
                                        class="table-dotted-border-bottom"
                                        >
                                            <!-- style="height:40vh; overflow-y: scroll;" -->
                                            <thead>
                                                <tr>
                                                    <th class="text-center" style="width: 5%">SL</th>
                                                    <th class="text-left" style="width: 25%">Employee Code</th>
                                                    <th class="text-left" style="width: 25%">Employee Name</th>
                                                    <th class="text-left" style="width: 25%">Employee Designation</th>
                                                    <th class="text-right" style="width: 10%">Net Payable</th>
                                                    <th class="text-center" style="width: 10%">Paid</th>
                                                    <th class="text-right" style="width: 15%">Remaining Bonus</th>
                                                </tr>
                                            </thead>

                                            <tbody>
                                                <tr
                                                v-for="(item, index) in getBonusProcessDetailsList"
                                                v-if="getBonusProcessDetailsList.length > 0"
                                                :key="index"
                                                >
                                                    <td class="text-center py-1">{{ index + 1 }}</td>

                                                    <td
                                                    class="text-left py-1"
                                                    style="white-space: normal"
                                                    >
                                                        {{ item?.employee?.code }}
                                                    </td>

                                                    <td
                                                    class="text-left py-1"
                                                    style="white-space: normal"
                                                    >
                                                         {{ item?.employee?.name }}
                                                    </td>

                                                    <td
                                                    class="text-left py-1"
                                                    style="white-space: normal"
                                                    >
                                                         {{ item?.designation?.name }}
                                                    </td>

                                                    <td
                                                    class="text-right py-1"
                                                    style="white-space: normal"
                                                    >
                                                        {{ item.payable_amount }}
                                                    </td>

                                                    <td class="text-right py-2">
                                                        <v-text-field
                                                            style="width: 150px"
                                                            :min="1"
                                                            type="number"
                                                            density="compact"
                                                            variant="outlined"
                                                            bg-color="grey-lighten-4"
                                                            v-model.number="item.paid"
                                                            hide-details="auto"
                                                            :error="item.paid < 1 || item.paid > item.remaining_amount"
                                                            :error-messages="getPaidErrors(item)"
                                                        ></v-text-field>
                                                    </td>

                                                    <td
                                                    class="text-right py-1"
                                                    style="white-space: normal"
                                                    >
                                                        {{ item.remaining_amount }}
                                                    </td>
                                                </tr>
                                                <tr v-else>
                                                    <td colspan="6" class="text-center text-red">
                                                        You have no item
                                                    </td>
                                                </tr>
                                            </tbody>
                                        </v-table>
                                    </v-col>
                                </v-row>

                                <!-- Close Cart Table -->

                                <v-divider></v-divider>
                                <v-card-actions>
                                    <v-row class="pt-2">
                                        <v-col cols="12">
                                            <v-layout class="justify-end">
                                            <v-btn
                                                class="bg-primary"
                                                variant="flat"
                                                @click="submitForm()"
                                                >Payment</v-btn
                                            >
                                            </v-layout>
                                        </v-col>
                                    </v-row>
                                </v-card-actions>
                                </v-form>
                            </v-expansion-panel-text>
                        </v-expansion-panel>
                    </v-expansion-panels>
                </v-col>
            </v-row>
        </v-container>
    </v-app>
</template>

<script>
import formattedDate from "@/plugins/dateFormatter";
import { useField, useForm } from "vee-validate";
import { getCurrentInstance, ref } from "vue";
import { useRouter } from "vue-router";
import { toast } from "vue3-toastify";
import { useStore } from "vuex";
import * as yup from "yup";
export default {
    components: {},
    data: () => ({
        panel: [0],
        panel2: [0],

        accountHeads: [],
        paymentMethods: [
            { title: "Cash", value: "CASH" },
            { title: "Bank", value: "BANK" },
            { title: "Mobile Banking", value: "MOBILE_BANKING" },
        ],
        years: [],
        months: [
            { title: "January", value: 1 },
            { title: "February", value: 2 },
            { title: "March", value: 3 },
            { title: "April", value: 4 },
            { title: "May", value: 5 },
            { title: "June", value: 6 },
            { title: "July", value: 7 },
            { title: "August", value: 8 },
            { title: "September", value: 9 },
            { title: "October", value: 10 },
            { title: "November", value: 11 },
            { title: "December", value: 12 },
        ],
        cart: [],

        paymentAccountHeadLoading: false,
        bonusProcessMasterLoading: false,

        errorMessages: "",
        visible: false,
        search: "",
    }),
    watch: {
        "month.value.value"(val) {
            if (!this.year.value.value && !val) {
                this.$store.commit("UNSET_BONUS_PROCESS_DETAILS_LIST");
                return;
            }   
            this.$store.dispatch("getBonusProcessList", {month:val, year:this.year.value.value});  
        },
        "year.value.value"(val) {
            if (!this.year.value.value && !val) {
                this.$store.commit("UNSET_BONUS_PROCESS_DETAILS_LIST");
                return;
            }   
            this.$store.dispatch("getBonusProcessList", {month:val, year:this.year.value.value});
        },
        "payment_method.value.value"(val) {
            this.paymentAccountHeadLoading = true;
            this.$store.dispatch('getPaymentAccountHeads', {
                payment_method: val
            }).then((res) => {
                this.accountHeads = res.data;
                this.paymentAccountHeadLoading = false;
            });
        },
    },
    created() {
        // if (this.$store.getters.getWarehouseList.length === 0) {
            this.$store.dispatch("getWarehouseList");
        // }
        // if (this.$store.getters.getSupplierList.length === 0) {
            this.$store.dispatch("getSupplierList");
        // }
        // if (this.$store.getters.getProductMapList.length === 0) {
            this.$store.dispatch("getProductMapList");
        // }
        // if (this.$store.getters.getPurRequisitionList.length === 0) {
            this.$store.dispatch("getPurRequisitionList");
        // }
    },
    computed: {

        getBonusProcessList(){
            return this.$store.getters.getBonusProcessList;
        },
        getBonusProcessDetailsList(){
            console.log(this.$store.getters.getBonusProcessDetailsList);
            return this.$store.getters.getBonusProcessDetailsList;
        },
        getPaymentMethodList() {
            return this.paymentMethods;
        },
        getAccountHeadList() {
            return this.accountHeads;
        },
        getYearsList() {
            const currentYear = new Date().getFullYear();
            const years = [];
            for (let i = currentYear - 5; i <= currentYear + 5; i++) {
                 this.years.push(i);
            }
            return this.years;
        },
        getMonthsList() {
            return this.months;
        },

        branchId() {
            return this.$store.getters.getAuthUser.branch_id || null;
        },
        getWarehouseList() {
            return this.$store.getters.getWarehouseList;
        },
        getProductMapList() {
            let products = this.$store.getters.getProductMapList;
            return products.filter(
                (item) => item.branch_id == this.branchId && item.status == 1
            );
        },
        getSupplierList() {
            return this.$store.getters.getSupplierList;
        },
        filteredPurRequisitionList() {
            const requisitions = this.$store.getters.getPurRequisitionList || [];
            return requisitions.filter(
                (item) => item.branch_id == this.branchId && item.status == 1
            );
        },
    },
    methods: {
        async onBonusProcessChange(selectedId) {
            if (!selectedId) {
                this.$store.commit("UNSET_BONUS_PROCESS_DETAILS_LIST");
                return;
            }
            this.$store.dispatch("getBonusProcessDetailsList", selectedId);

        },
        getPaidErrors(item) {
            const errors = [];

            if (item.paid < 1) {
                errors.push("Paid Amount must be greater than 0");
            }
            if (item.paid > item.remaining_amount) {
                errors.push("Paid Amount must be lesser or equal to Remaining Bonus");
            }

            return errors;
        }
    },
    setup() {
        const { proxy } = getCurrentInstance();
        const { handleSubmit, resetForm } = useForm({
            validationSchema: yup.object({
                payment_date: yup.string().required().label("Payment Date"),
                payment_method: yup.string().required().label("Payment Date"),
                payment_account_head_id: yup.number().required().label("Payment Date"),
                month: yup.number().required().label("Payment Date"),
                year: yup.number().required().label("Payment Date"),
                bonus_process_master_id: yup.string().required().label("Bonus Process Master"),
            }),
        });

        const payment_date = useField("payment_date");
        const payment_method = useField("payment_method");
        const payment_account_head_id = useField("payment_account_head_id");
        const payment_status = useField("payment_status");
        const bonus_process_master_id = useField('bonus_process_master_id');
        const month = useField("month");
        const year = useField("year");
        
        const remarks = useField("remarks");
        
        const errorMessages = ref("");
        const cart = ref([]);
        const loading = ref("");
        const buttonText = ref("");
        buttonText.value = "Save";
        const store = useStore();
        const router = useRouter();

        const currentStatus = ref("");

        const submitForm = () => {
            submit();
        };

        const submit = handleSubmit((values) => {
            values.employee_id = (store.getters.getBonusProcessDetailsList || []).map(item => item.employee_id);
            values.bonus_process_detail_id = (store.getters.getBonusProcessDetailsList || []).map(item => item.id);
            values.paid = (store.getters.getBonusProcessDetailsList || []).map(item => item.paid);
            store.dispatch("saveUpdateBonusPayment", values)
            .then((response) => {
                resetForm();
                buttonText.value = "Save";
                store.commit("UNSET_BONUS_PROCESS_DETAILS_LIST");
                toast.success(response.data.message, {
                    timeout: 3000,
                });
                // store.dispatch('getSalaryPaymentList');
                setTimeout(() => {
                    router.push({ name: "bonus-payment-order-list" });
                }, 2000);
            })
            .catch((error) => {
                toast.error(error.response.data.message);
            });
        });

        return {
            submitForm,
            submit,
            payment_date,
            payment_method,
            payment_account_head_id,
            payment_status,
            month,
            year,
            bonus_process_master_id,
            remarks,
            cart,
            errorMessages,
            buttonText,
            loading,
        };
    },

};
</script>
